import { type AxiosRequestConfig } from 'axios'

const refreshToken = (): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: '/auth/refresh',
  }
}

export { refreshToken }
